export default function MomentDate() {
    return function(input, format) {
        return moment(input).format(format);
    };
}



// WEBPACK FOOTER //
// ./src/app/filters/momentDate.filter.js